import { server } from './config'
import { useToken } from './hooks'
import {
  Query,
  QueryKey,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'

type ApiProps<T> = {
  queryKeys?: (string | undefined)[]
  enabled?: boolean
  refetchInterval?:
    | number
    | false
    | ((query: Query<T, Error, T, QueryKey>) => number | false | undefined)
    | undefined
}

export const useApi = <T>(uri: string, options?: ApiProps<T>) => {
  const token = useToken()
  const queryClient = useQueryClient()
  const { queryKeys = [], ...remainingOptions } = options || {}

  const getter = async () => {
    const res = await fetch(`${server}${uri}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (!res.ok) throw new Error('Failed to fetch data')
    return res.json() as T
  }

  const result = useQuery<T>({
    queryKey: [uri, ...queryKeys, token],
    queryFn: getter,
    ...remainingOptions,
  })

  return {
    ...result,
    revalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [uri, ...queryKeys, token],
      }),
  }
}
